<template>
  <div :class="['wrapper', classes]">

    <!-- Horizontal bar at top. Contains messages, notifications, tasks and user menu -->
    <dash-header :user="user"></dash-header>
    
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :user="user" />
  
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1 v-if="idioma === 'DE'">
          {{$route.meta.nameDe.toUpper}}
          <small>{{ $route.meta.descriptionDe }}</small>
        </h1>
        <h1 v-else-if="idioma === 'EN'">
          {{$route.meta.nameEn}}
          <small >{{ $route.meta.descriptionEn }}</small>
        </h1>
        <h1  v-else-if="idioma === 'ES'">
          {{$route.meta.nameEs}}
          <small>{{ $route.meta.descriptionEs }}</small>
        </h1>
        <h1 v-else>
          {{$route.meta.namePtBr}}
          <small >{{ $route.meta.descriptionPtBr }}</small>
        </h1>
        <ol class="breadcrumb" v-if="idioma === 'DE'">
          <li>
            <a href="javascript:;">
              <i class="fa fa-home"></i>Hauptsächlich</a>
          </li>
          <li class="active">{{$route.nameDe}}</li>
        </ol>
        <ol class="breadcrumb" v-else-if="idioma === 'EN'">
          <li>
            <a href="javascript:;">
              <i class="fa fa-home"></i>Home</a>
          </li>
          <li class="active">{{$route.nameEn}}</li>
        </ol>
        <ol class="breadcrumb" v-else-if="idioma === 'ES'">
          <li>
            <a href="javascript:;">
              <i class="fa fa-home"></i>Principal</a>
          </li>
          <li class="active">{{$route.nameEs}}</li>
        </ol>
        <ol class="breadcrumb" v-else>
          <li>
            <a href="javascript:;">
              <i class="fa fa-home"></i>Principal</a>
          </li>
          <li class="active">{{$route.namePtBr}}</li>
        </ol>
      </section>

      <router-view></router-view>
    </div>
    <!-- /.content-wrapper -->
  
    <!-- Horizontal bar at bottom. Contains copy right -->
    <dash-footer></dash-footer>
  </div>
</template>

<script>
import config from '../config'
import DashFooter from './layout/DashFooter'
import DashHeader from './layout/DashHeader'
import Sidebar from './layout/Sidebar'
import 'hideseek'

export default {
  name: 'Dash',
  components: {
    DashFooter,
    DashHeader,
    Sidebar
  },
  data: function () {
    return {
      // section: 'Dash',
      idioma: config.idioma,
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      }
    }
  },
  computed: {
    user () {
      return {
        displayName: this.$store.state.user.displayName,
        avatar: config.iconeInterno,
        email: this.$store.state.user.email
      }
    }
  }
}
</script>

<style>
.wrapper.fixed_layout .main-header {
  position: fixed;
  width: 100%;
}
.wrapper.fixed_layout .content-wrapper {
  padding-top: 50px;
}
.wrapper.fixed_layout .main-sidebar {
  position: fixed;
  height: 100vh;
}

@media (max-width: 767px) {
  .wrapper.hide_logo .main-header .logo {
    display: none;
  }
}

.logo-mini,
.logo-lg {
  text-align: left;
}
.logo-mini img,
.logo-lg img {
  padding: 0.4em !important;
}

.logo-lg img {
  display: -webkit-inline-box;
  width: 25%;
}

.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}
</style>



// WEBPACK FOOTER //
// Dash.vue?7372d3d3